export type SubscriptionStatus =
  | 'ACTIVE'
  | 'TRIALING'
  | 'PAST_DUE'
  | 'CANCELED'
  | 'CANCELLED'
  | 'SUSPENDED'
  | 'INACTIVE'

export type PlanType =
  | 'TRIAL'
  | 'STARTER'
  | 'PRO'
  | 'SCALE'
  | 'ENTERPRISE'
  | 'PARTNER'
  | 'COURTESY'

export interface PlanLimits {
  channels: number | null
  members: number | null
  aiAgents: number | null
  cadenceEnrollments: number | null
  followUpConfigs: number | null
  messagesPerMonth: number | null
}

export interface PlanUsage {
  channels: number
  members: number
  aiAgents: number
  cadenceEnrollments: number
  followUpConfigs: number
  messagesThisMonth: number
}

export interface ActiveAddon {
  id: string
  type: 'EXTRA_CHANNEL' | 'MESSAGE_PACK'
  quantity: number
  unitPrice: number
  totalPrice: number
}

export interface BillingOverview {
  planType: PlanType
  subscriptionStatus: SubscriptionStatus
  hasStripeSubscription: boolean
  periodStart: string | null
  periodEnd: string | null
  limits: PlanLimits
  usage: PlanUsage
  addons: ActiveAddon[]
  estimatedMonthlyTotal: number
  billingOwnerUserId: string | null
  billingOwnerName: string | null
}

export interface AddonPreview {
  addonType: 'EXTRA_CHANNEL' | 'MESSAGE_PACK'
  quantity: number
  currentUsage: number
  currentLimit: number | null
  newLimit: number | null
  additionalCost: number
  newMonthlyTotal: number
  billingStartsAt: string
}

export interface DowngradePreview {
  targetPlan: PlanType
  exceedingItems: Array<{
    resource: string
    current: number
    newLimit: number | null
    excess: number
  }>
  newMonthlyTotal: number
}

export const subscriptionStatusLabel: Record<SubscriptionStatus, string> = {
  ACTIVE: 'Ativa',
  TRIALING: 'Teste',
  PAST_DUE: 'Pagamento atrasado',
  CANCELED: 'Cancelada',
  CANCELLED: 'Cancelada',
  SUSPENDED: 'Suspensa',
  INACTIVE: 'Inativa',
}

export const planLabel: Record<PlanType, string> = {
  TRIAL: 'Trial',
  STARTER: 'Starter',
  PRO: 'Pro',
  SCALE: 'Scale',
  ENTERPRISE: 'Enterprise',
  PARTNER: 'Partner',
  COURTESY: 'Courtesy',
}

export const PLAN_LIMITS: Record<'STARTER' | 'PRO' | 'SCALE', PlanLimits> = {
  STARTER: {
    channels: 2,
    members: 10,
    aiAgents: 5,
    cadenceEnrollments: 1000,
    followUpConfigs: 2,
    messagesPerMonth: 10000,
  },
  PRO: {
    channels: 3,
    members: 20,
    aiAgents: 10,
    cadenceEnrollments: 5000,
    followUpConfigs: 5,
    messagesPerMonth: 20000,
  },
  SCALE: {
    channels: 4,
    members: 40,
    aiAgents: 15,
    cadenceEnrollments: 25000,
    followUpConfigs: 15,
    messagesPerMonth: 50000,
  },
}

export const PRO_LIMITS: PlanLimits = PLAN_LIMITS.PRO
